module.exports = __webpack_public_path__ + "static/media/hand-spock.a050abce.svg";